module.exports = __webpack_public_path__ + "3da3b2887923a28a8f4fef18cf64ad03.png";